import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteReserConnectivity, EditReserConnectivity, ReserVoucherConnectivity, SaveReserConnectivity } from "../../Services/Service";

// ✅ Async Thunk
export const fetchConnectivity = createAsyncThunk(
    "connectivity/fetchConnectivity",
    async (propertyId) => {
        const response = await ReserVoucherConnectivity(propertyId);
        return response;
    }
);

export const saveConnectivity = createAsyncThunk(
    "connectivity/saveConnectivity",
    async (postData) => {
        const response = await SaveReserConnectivity(postData);
        return response;
    }
);

export const deleteConnectivity = createAsyncThunk(
    "connectivity/deleteConnectivity",
    async (id) => {
        await DeleteReserConnectivity(id);
        return id;   // 👈 sirf id return karenge
    }
);


export const updateConnectivity = createAsyncThunk(
    "connectivity/updateConnectivity",
    async (postData) => {
        const response = await EditReserConnectivity(postData);
        return response;
    }
);

const connectivitySlice = createSlice({
    name: "connectivity",
    initialState: {
        connectivityList: [],
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchConnectivity.fulfilled, (state, action) => {
                state.connectivityList = action.payload;
            })
            .addCase(fetchConnectivity.rejected, (state, action) => {
                state.error = action.error.message;
            })

            .addCase(deleteConnectivity.fulfilled, (state, action) => {
                // ✅ Local state se remove
                state.connectivityList = state.connectivityList.filter(
                    item => item.ID !== action.payload
                );
            })

            .addCase(updateConnectivity.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateConnectivity.fulfilled, (state, action) => {
                state.loading = false;

                const updatedItem = action.payload;

                const index = state.connectivityList.findIndex(
                    item => item.ID === updatedItem.ID
                );

                if (index !== -1) {
                    state.connectivityList[index] = updatedItem;
                }
            })
            .addCase(updateConnectivity.rejected, (state) => {
                state.loading = false;
            })
    },
});

export default connectivitySlice.reducer;